import React from 'react';
import css from './css.module.less';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { useSelector, useDispatch } from 'react-redux';
import {
  getPageStyleList,
  currentSelectedStyle,
  // currentSalesChannelUuid,
  // getCurrentStyleList,
  updateSelectedStyle,
} from 'src/constrains/SalesChannelStyleSelect/slice';
import DropDown from 'src/constrains/DropdownHOC';
import { Menu, MenuItem } from 'src/components/Antd';
import { modal } from 'src/utils/Modal';
import { Icon } from '@/src/tools/icon';
import {
  urlParamsKey,
  EnumMultiLanguageType,
} from 'src/constrains/SalesChannelMultiLanguageSelect';
import { useRouteMatch } from 'react-router-dom';
import { WebSiteSubType } from 'src/types/common/SalesChannel';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Text = {
  [WebSiteSubType.ResponsivePage]: 'Responsive Site',
  [WebSiteSubType.NativeMobile]: 'Native Mobile Site',
};

const WebSiteTypeSelectDropDown = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    options,
    handleOnConfirm,
    selected,
    onDropDownChange,
    warningBeforeSwitch,
  } = props;
  const _handleOnConfirm = (e) => {
    if (warningBeforeSwitch) {
      modal.error({
        title: getI18nFromGeneral('general.commonHeader.leave_header'),
        content: getI18nFromGeneral('general.commonHeader.leave_content'),
        onCancel: () => {
          onDropDownChange(false);
        },
        onCancelText: getI18n('general.cancel'),
        onOk: () => {
          handleOnConfirm(e);
          onDropDownChange(false);
        },
        okText: 'Leave',
      });
    } else {
      handleOnConfirm(e);
      onDropDownChange(false);
    }
  };
  return (
    <div className={css.container}>
      <Menu onSelect={_handleOnConfirm} selectedKeys={selected}>
        {options.map((menu) => {
          const { value, label, hasError } = menu || {};
          return (
            <MenuItem className={css.subMenu} key={value}>
              <React.Fragment>
                {label}
                {hasError && (
                  <Icon type='iconinfo1' className={css.errIconOption} />
                )}
              </React.Fragment>
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

const WebSiteTypeSelectTrigger = (props) => {
  const { className, title, titleHasError } = props;

  return (
    <div className={`${css.mldContainer} ${className}`}>
      {title && (
        <React.Fragment>
          <span className={css.mldTitle}>{title}</span>
          <Icon type='icondown' />
          {titleHasError && (
            <Icon type='iconinfo1' className={css.errIconTitle} />
          )}
        </React.Fragment>
      )}
    </div>
  );
};

const StyleDropdown = DropDown(
  WebSiteTypeSelectTrigger,
  WebSiteTypeSelectDropDown,
);

const SalesChannelStyleDropdown = React.memo((props: any) => {
  const { hasModified, salesChannelUuidKey, customType } = props;
  const match = useRouteMatch();
  const { params }: any = match;
  const { saleChannelUuid } = params;

  let type = customType
    ? customType
    : EnumMultiLanguageType.SalesChannelContent;
  if (params.contentUuid) {
    type = EnumMultiLanguageType.SalesChannelContent;
  } else if (params.salesChannelProductUuid) {
    type = EnumMultiLanguageType.SalesChannelProduct;
  } else if (params.legalPageUuid) {
    type = EnumMultiLanguageType.SalesChannelLegalPage;
  } else if (params.TcUuid) {
    type = EnumMultiLanguageType.SalesChannelTermsCondition;
  } else if (params.collectionsUuid) {
    type = EnumMultiLanguageType.SalesChannelCollection;
  }

  //暂时先这么写，以后要传参数再说吧

  const _key = urlParamsKey[type];

  const d = useDispatch();

  const uuid = params[_key];
  const key = `${uuid}${type}`;

  const selectedStyle = useSelector(currentSelectedStyle());
  //console.log('selectedStyle', selectedStyle);

  const result = useSelector(getPageStyleList(key)) || [];
  //const isPrimary = useSelector(isPrimaryLanguage());
  //console.log(result, 'result');
  const options = result.map((i) => {
    const { siteStyle, hasError } = i;
    return { label: Text[siteStyle] || siteStyle, value: siteStyle, hasError };
  });

  const hasError = result.filter((i) => i.hasError).length > 0;
  const handleStyleOnChange = (e) => {
    const { key } = e;

    d(
      updateSelectedStyle({
        salesChannelUuid: !salesChannelUuidKey
          ? saleChannelUuid
          : params[salesChannelUuidKey],
        selectedStyle: key,
      }),
    );
  };

  //console.log(options, 'options=======');

  return (
    <StyleDropdown
      warningBeforeSwitch={hasModified}
      options={options}
      titleHasError={hasError}
      title={Text[selectedStyle] || selectedStyle}
      selected={selectedStyle}
      dropdownProps={{ maxWidth: 300, maxHeight: 500 }}
      handleOnConfirm={handleStyleOnChange}
    />
  );
});

export default SalesChannelStyleDropdown;
